<template>
  <div>
    {{ $props.label }}
    <v-otp-input
      length="6"
      v-bind="$props"
      :value="modelValue"
      @input="(newValue) => (modelValue = newValue)"
    ></v-otp-input>
  </div>
</template>
<script lang="ts">
import { Component, Prop } from 'vue-property-decorator';
import { VOtpInput } from 'vuetify/lib/components';

@Component({
  components: {
    VOtpInput,
  },
})
export default class FOTP extends VOtpInput {
  // MODEL VALUE - START
  @Prop()
  value: string;

  get modelValue() {
    return this.value;
  }

  set modelValue(newModelValue: string) {
    this.$emit('input', newModelValue);
  }
  // MODEL VALUE - END
}
</script>
